import { EduIntro, EduList } from "../styles/Education.styled";
import { Wrapper } from "../styles/Output.styled";

const Education = () => {
  return (
    <Wrapper data-testid="education">
      <EduIntro>Here is my education background!</EduIntro>
      {eduBg.map(({ title, desc }) => (
        <EduList key={title}>
          <div className="title">{title}</div>
          <div className="desc">{desc}</div>
        </EduList>
      ))}
    </Wrapper>
  );
};

const eduBg = [
  {
    title: "Master's in Computer Science",
    desc: "University of Montpellier | 2023 - 2025",
  },
  {
    title: "B.Sc in Nuclear Power Engineering",
    desc: "National Research Nuclear University MEPhI | 2019 - 2023",
  },
];

export default Education;
